import * as React from 'react';
import styled from 'styled-components';

export type AppBarProps = {
  position?: 'static' | 'relative' | 'absolute' | 'sticky';
  backgroundColor?: string;
};

const AppBarRoot = styled.header<AppBarProps>((props) => ({
  position: props.position ?? 'relative',
  top: 0,
  left: 0,
  right: 0,
  height: 'var(--app-bar-height)',
  padding: props.theme.spacing(0, 1),
  willChange: 'opacity',
  backgroundColor: props.backgroundColor ?? props.theme.blue15,
  zIndex: 100,

  [props.theme.breakpoints.up('sm')]: {
    padding: props.theme.spacing(0, 1.5),
  },

  [props.theme.breakpoints.up('lg')]: {
    height: 'var(--app-bar-height-lg)',
    padding: 0,
  },
}));

const ContentRoot = styled.div(({ theme }) => ({
  width: '100%',
  maxWidth: theme.contentMaxWidth,
  height: 'inherit',
  minHeight: 'inherit',
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const AppBar = React.forwardRef<
  HTMLElement,
  React.PropsWithChildren<AppBarProps>
>(function AppBar(props, ref) {
  const { children, ...rest } = props;
  return (
    <AppBarRoot ref={ref} {...rest}>
      <ContentRoot>{children}</ContentRoot>
    </AppBarRoot>
  );
});

export default AppBar;
